import React from 'react';


export default class NotFoundPage extends React.Component {

  render() {
    console.log('props', this.props);
    return (
      <div>NotFoundPage</div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/pages/NotFoundPage.jsx